import { useState, useEffect } from 'react'

import { screenWidthBreakpoints } from 'styles/shared'

const useScreenSize = () => {
  const getSize = () => {
    if (typeof window === 'undefined') {
      return 'large'
    }
    const windowWidth = window.innerWidth

    if (windowWidth < screenWidthBreakpoints.minMedium) {
      return 'small'
    } else if (windowWidth <= screenWidthBreakpoints.maxMedium) {
      return 'medium'
    }
    return 'large'
  }

  const [screenSize, setScreenSize] = useState(getSize)

  useEffect(() => {
    if (typeof window === 'undefined') return

    const handleResize = () => setScreenSize(getSize())

    window.addEventListener('resize', handleResize)

    handleResize()

    return () => window.removeEventListener('resize', handleResize)
  }, [])

  return screenSize
}

export default useScreenSize
